"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabStyles = exports["default"] = exports.Tab = void 0;
var _react = _interopRequireDefault(require("react"));
var _system = require("@chakra-ui/system");
var _ = require("..");
var _utils = require("../../system/utils");
var _excluded = ["isActive", "isDisabled", "variant", "syncIconStyle", "key", "href", "analyticsName", "aria-label"],
  _excluded2 = ["variant", "isActive", "isDisabled", "syncIconStyle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_2ovd415noz() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Tab/Tab.tsx";
  var hash = "aa7b1663eaaab3349c0deb566ad66516adb03c2e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Tab/Tab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "1": {
        start: {
          line: 50,
          column: 34
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "2": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "3": {
        start: {
          line: 74,
          column: 28
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "4": {
        start: {
          line: 81,
          column: 17
        },
        end: {
          line: 81,
          column: 61
        }
      },
      "5": {
        start: {
          line: 83,
          column: 18
        },
        end: {
          line: 83,
          column: 20
        }
      },
      "6": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "7": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 27
        }
      },
      "8": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 89,
          column: 3
        }
      },
      "9": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 29
        }
      },
      "10": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 92,
          column: 3
        }
      },
      "11": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 34
        }
      },
      "12": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 94,
          column: 31
        }
      },
      "13": {
        start: {
          line: 97,
          column: 0
        },
        end: {
          line: 99,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 7
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 74,
            column: 28
          },
          end: {
            line: 74,
            column: 29
          }
        },
        loc: {
          start: {
            line: 80,
            column: 54
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 80
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 84
      },
      "1": {
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 87
      },
      "2": {
        loc: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 90
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aa7b1663eaaab3349c0deb566ad66516adb03c2e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ovd415noz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ovd415noz();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Tab component is used to render a tab UI, which supports different
 * variants.
 *
 * The `Tab` component uses chakra UI to build variant styles.
 *
 * Tab variant variations
 * ----------------------------------------------------------------------------------------------
 *
 * "nav-item"
 *
 * "nav-link"
 *
 * "app-nav"
 *
 * "sub-nav"
 */
var Tab = exports.Tab = (cov_2ovd415noz().s[0]++, (0, _system.forwardRef)(function (_ref, ref) {
  var isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    variant = _ref.variant,
    syncIconStyle = _ref.syncIconStyle,
    _key = _ref.key,
    href = _ref.href,
    analyticsName = _ref.analyticsName,
    ariaLabel = _ref['aria-label'],
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2ovd415noz().f[0]++;
  var _ref2 = (cov_2ovd415noz().s[1]++, useTabStyles(_objectSpread({
      variant: variant,
      isActive: isActive,
      isDisabled: isDisabled,
      syncIconStyle: syncIconStyle
    }, props))),
    className = _ref2.className,
    styles = _ref2.styles;
  cov_2ovd415noz().s[2]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react["default"].createElement(_.Link, _extends({
      ref: ref,
      className: className
      // __css has a lower priority than sx
      ,
      __css: styles,
      analyticsName: analyticsName,
      "aria-label": ariaLabel,
      "aria-current": isActive
    }, props))
  );
}));
cov_2ovd415noz().s[3]++;
var useTabStyles = exports.useTabStyles = function useTabStyles(_ref3) {
  var variant = _ref3.variant,
    isActive = _ref3.isActive,
    isDisabled = _ref3.isDisabled,
    syncIconStyle = _ref3.syncIconStyle,
    props = _objectWithoutProperties(_ref3, _excluded2);
  cov_2ovd415noz().f[1]++;
  var styles = (cov_2ovd415noz().s[4]++, (0, _utils.useStyleConfig)('Tab', _objectSpread({
    variant: variant
  }, props)));
  var className = (cov_2ovd415noz().s[5]++, '');
  cov_2ovd415noz().s[6]++;
  if (isActive) {
    cov_2ovd415noz().b[0][0]++;
    cov_2ovd415noz().s[7]++;
    className += ' active';
  } else {
    cov_2ovd415noz().b[0][1]++;
  }
  cov_2ovd415noz().s[8]++;
  if (isDisabled) {
    cov_2ovd415noz().b[1][0]++;
    cov_2ovd415noz().s[9]++;
    className += ' disabled';
  } else {
    cov_2ovd415noz().b[1][1]++;
  }
  cov_2ovd415noz().s[10]++;
  if (syncIconStyle) {
    cov_2ovd415noz().b[2][0]++;
    cov_2ovd415noz().s[11]++;
    className += ' syncIconStyle';
  } else {
    cov_2ovd415noz().b[2][1]++;
  }
  cov_2ovd415noz().s[12]++;
  return {
    styles: styles,
    className: className
  };
};
cov_2ovd415noz().s[13]++;
Tab.defaultProps = {
  variant: 'nav-item'
};
var _default = exports["default"] = Tab;